import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataServiceService } from '../../services/data-service.service';
import { AuthService } from '../../services/auth.service';
import type { TruckContact } from './send-dispatch.helpers';

@Component({
  selector: 'app-send-dispatch',
  templateUrl: './send-dispatch.component.html',
  styleUrl: './send-dispatch.component.scss',
  providers: [MessageService]
})

export class SendDispatchComponent {
  visible = false;
  dispatchText = '';
  emailAddress = '';
  sending = false;

  /** Shown in the dialog header; set per open for the current driver only. */
  displayTruckNumber = '';
  /** Suggested TO when opening; user may edit. */
  defaultTruckEmail = '';

  constructor(
    private messageService: MessageService,
    private dataService: DataServiceService,
    private authService: AuthService
  ) {}

  /**
   * @param text Full plain-text body (built by the parent for that driver).
   * @param contact Truck inbox + label for that driver only (no global lists in this component).
   */
  showEmailDialog(text: string, contact: TruckContact) {
    this.dispatchText = text;
    this.displayTruckNumber = contact.truckNumber;
    this.defaultTruckEmail = contact.truckEmail;
    this.emailAddress = contact.truckEmail;
    this.visible = true;
  }

  closeEmailDialog() {
    this.visible = false;
    this.emailAddress = '';
    this.defaultTruckEmail = '';
    this.displayTruckNumber = '';
  }

  isValidEmail(): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(this.emailAddress);
  }

  sendEmail() {
    if (!this.isValidEmail()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please enter a valid email address'
      });
      return;
    }

    this.sending = true;

    const formattedBody = this.dispatchText
      .replace(/\n/g, '\r\n')
      .replace(/\r\r\n/g, '\r\n');

    const userInfo = this.authService.getUserProfile();
    const emailData = {
      from_email: userInfo?.email,
      to: this.emailAddress,
      subject: 'Dispatch Orders',
      body: formattedBody,
    };

    this.dataService.sendEmail(emailData).subscribe({
      next: (response: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.message || 'Email sent successfully'
        });
        this.sending = false;
        this.closeEmailDialog();
      },
      error: (error) => {
        console.error('Error sending email:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to send email: ' + (error.error?.detail || 'Unknown error')
        });
        this.sending = false;
      }
    });
  }
}
